/**
 * @desc 账号登录
 */
import { LoginResult, LoginMfaForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginOperationByMfaParameter = LoginMfaForm

const method = 'POST'
const url = '/auth/operation/login/mfa'

export const loginOperationByMfaApi = (
  data?: LoginOperationByMfaParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    data,
    ...config
  })
}

loginOperationByMfaApi.method = method
loginOperationByMfaApi.url = url
